import { spacing } from "globalStyles";
import { GenericStreetSection, Street } from "interfaces/content";
import styled from "styled-components";
import { breakpoints } from "themes/breakpoints";
import { CARD_ARROW_WIDTH } from "ui/List/Card";
import Cell from "ui/List/Cell";
import FeeCell from "../FeeCell";

interface CardExtraInfoProps {
  collapsedInfo: Partial<Street["collapsedInfo"]>;
  cellConfig: GenericStreetSection["data"]["cellConfig"];
}

const CardExtraInfo = ({
  cellConfig,
  collapsedInfo: { image, ...collapsedInfo },
}: CardExtraInfoProps) => {
  const parsedCells = Object.keys(collapsedInfo).map((key) => ({
    key,
    value: collapsedInfo[key],
  }));

  return (
    <Container>
      <ContentContainer>
        {parsedCells &&
          parsedCells.length > 0 &&
          parsedCells.map((cell) => {
            if (Array.isArray(cell.value)) {
              if (!cell.value.length) return null;

              return (
                <FeeCell
                  key={`${cellConfig?.[cell.key]?.label}_${cell.value}`}
                  size={cellConfig?.[cell.key]?.size}
                  label={cellConfig?.[cell.key]?.label}
                  fees={cell.value}
                  className={cellConfig?.[cell.key]?.className}
                />
              );
            }

            return (
              <Cell
                key={`${cellConfig?.[cell.key]?.label}_${cell.value}`}
                size={cellConfig?.[cell.key]?.size}
                label={cellConfig?.[cell.key]?.label}
                value={cell.value}
                className={cellConfig?.[cell.key]?.className}
              />
            );
          })}
      </ContentContainer>

      <Img
        src={`${process.env.REACT_APP_BASE_RELATIVE_ROUTES}/assets/${image?.path}`}
        alt={image?.alt}
      />
    </Container>
  );
};

export default CardExtraInfo;

const Container = styled.div`
  margin-top: ${spacing.small}px;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  width: calc(100% - ${CARD_ARROW_WIDTH}px);

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;

    .cell:not(:first-of-type) {
      margin-top: ${spacing.small}px;
    }
  }
`;

const Img = styled.img`
  margin-top: ${spacing.small}px;
  width: 100%;

  @media (max-width: ${breakpoints.md}) {
    margin-top: ${spacing.medium}px;
  }
`;
